import React from "react";
import styled from "styled-components";
import { graphql, StaticQuery } from "gatsby";
import PreviewCompatibleImage from "./PreviewCompatibleImage";
import Button from "./Button";
import IconBell from "./Icons/IconBell";
import { clearBg, colorMain, minDesktop, maxMobile } from "../styles";

const Wrapper = styled.div`
  background: ${clearBg};
  padding: 32px 16px;
  max-width: 656px;
  margin: 52px auto 0;

  @media (${minDesktop}) {
    padding: 48px;
  }
`;

const Display = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 36px;

  .gatsby-image-wrapper {
    width: 100%;
  }
`;

const Title = styled.h4`
  font-style: normal;
  font-weight: normal;
  font-size: 30px;
  line-height: 133%;
  letter-spacing: -0.021em;
  text-align: center;
  margin: 16px 0;

  @media (${maxMobile}) {
    font-size: 24px;
  }
`;

const Text = styled.p`
  margin: 0 0 24px;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 133%;
  letter-spacing: -0.014em;
  color: ${colorMain};
  text-align: center;

  @media (${maxMobile}) {
    font-size: 16px;
  }
`;

const ButtonWrapper = styled.div`
  max-width: 164px;
  margin: 42px auto 0;
`;

const AuthorBox = ({ image }) => {
  return (
    <Wrapper>
      <Display>{image && <PreviewCompatibleImage imageInfo={image} />}</Display>
      <Title>I’m Darren Rowse</Title>
      <Text>
        Speaker, Author, Blogger, Podcaster & Founder of ProBlogger & Digital
        Photography School. Ambassador for WorldVision Aus. Father of 3 boys &
        husband to Vanessa.
      </Text>
      <Text>If you would like to keep up to date with my posts here </Text>
      <ButtonWrapper>
        <Button
          options={{ as: "a", "data-formkit-toggle": "980bde946d", href: "#" }}
        >
          <IconBell /> Subscribe
        </Button>
      </ButtonWrapper>
    </Wrapper>
  );
};

export default () => (
  <StaticQuery
    query={graphql`
      query darrenImage {
        file(relativePath: { eq: "darren-rowse.png" }) {
          childImageSharp {
            fluid(maxWidth: 159, maxHeight: 159, quality: 100) {
              ...GatsbyImageSharpFluid
              ...GatsbyImageSharpFluidLimitPresentationSize
            }
          }
        }
      }
    `}
    render={(data, count) => <AuthorBox image={data.file} />}
  />
);
